import React from "react";

import ContentCore from "../../../../core/workingContent";

const FinishEarly = () => {
  return (
    <ContentCore />
  )
}

export default FinishEarly